import { connect } from 'react-redux';
import { withRouter } from '../../utils/withRouter';
import NewAddress from './newAddress'
import * as AC from '../../actions/actionCreators'

function mapStateToProps(state) { 
	return {
        visitorTerritory: state.profile.visitorTerritory,
        error: state.request.error,
        isSaving: state.request.isSaving,
        isLoading: state.city.isLoading,
        cities: state.city.cities.map( (c, index) => ({ key: index, value: c.city, text: c.city })),
        citiesWithPostalCode: state.city.citiesWithPostalCode,
        address: state.address.addresses.map( (c, index) => ({ key: index, value: c.address, text: c.address, hco: c.hco })),
        cityZipData: state.city.cityZipData
}};

function mapDispatchToProps(dispatch) {
    return({
        requestAddNewAddress: (visitorTerritory, license, city, postalCode, address, hco ) => { dispatch(AC.RequestAddNewAddressStarted(visitorTerritory, license, city, postalCode, address, hco) ) },
        fetchCities: () => { dispatch(AC.CityListLoadingStarted()) },
        fetchCitiesWithPostalCode: () => { dispatch(AC.CityWithPostalCodeListLoadingStarted()) },
        fetchAddress: (city) => { dispatch(AC.AddressListLoadingStarted(city, '', '', '', '')) },
        clearRequestUi: () => { dispatch(AC.ClearRequestUi()) }
    })
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewAddress));